import { Box, Group, Image, Paper, Stack, Text } from '@mantine/core';
import classes from './AsideMessage.module.css';
export type AsideMyMessageProps = {
  text: string;
};
export const AsideMyMessage: React.FC<AsideMyMessageProps> = ({
  text
}) => {
  return <Group justify="end">
      <Box p={8}>
        <Paper pos="relative" radius="sm" className={classes.myMessage}>
          <Image src="/assets/aside/mychat.svg" pos="absolute" w={12} bottom={0} right={-10} alt="decor" />
          <Stack p={12} gap={4}>
            <Text span inherit fz="xs" c="var(--text-white)" ml={4}>
              {text}
            </Text>
          </Stack>
        </Paper>
      </Box>
    </Group>;
};